/**
 * canvas-engine/renderer/elements/LogoElement.jsx
 *
 * OWN per-type element renderer for `logo` elements (header/footer chrome).
 *
 * ZERO REUSE: imports NOTHING from template-builder/ or academy-ui/src/template/.
 *
 * Inner-content vs positioning CONTRACT: renders ONLY the inner logo, filling
 * its positioned box. The parent CanvasRenderer owns positioning. DOM output is
 * identical in builder and reader modes. (Req 4.2, 17.1)
 *
 * Renders the logo image (resolved via OWN `assetRef`) or, when no image is
 * present, the brand text. Pure / presentational.
 */

import React from 'react';
import { assetRef } from '../../model/assetRef';

function str(v) {
  return v == null ? '' : String(v);
}

function color(v, fallback) {
  return typeof v === 'string' && v.length > 0 ? v : fallback;
}

function num(v, fallback) {
  return Number.isFinite(v) ? v : fallback;
}

/**
 * Render a logo image or brand text.
 *
 * @param {object} props
 * @param {object} props.element normalized `logo` Canvas_Element
 */
export default function LogoElement({ element }) {
  const content = (element && element.content) || {};
  const style = (element && element.style) || {};

  const asset = assetRef(content.asset);
  const src = asset.displayLink || asset.storedLink || '';
  const alt = str(content.alt) || 'Logo';
  const brandText = str(content.text) || str(content.brand);

  const rootStyle = {
    width: '100%',
    height: '100%',
    boxSizing: 'border-box',
    display: 'flex',
    alignItems: 'center',
    background: color(style.background, 'transparent'),
    borderRadius: num(style.radius, 0),
    overflow: 'hidden',
  };

  return (
    <div className="ce-logo" style={rootStyle}>
      {src ? (
        <img
          className="ce-logo__img"
          src={src}
          alt={alt}
          style={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'contain', display: 'block' }}
        />
      ) : (
        <span
          className="ce-logo__text"
          style={{ fontSize: num(style.fontSize, 22), fontWeight: 700, color: color(style.color, '#0f172a') }}
        >
          {brandText || alt}
        </span>
      )}
    </div>
  );
}
